import React from "react"
import {Button} from "antd"
import {withTranslation} from "react-i18next"
import {studentStaffContactsServiceV3, userPersonalContactsServiceV3} from "services"
import {BasePopup} from "components/popup"
import {BaseButton} from "components/buttons"
import {toastError, toastSuccess} from "helpers"
import styles from "./AddContactForm.module.css"

type Props = {
    isShow: boolean
    onClose: Function
    data?: any
    isRelatedTo?: boolean
    t: Function
}

type State = {
    isLoading: boolean
}

class RemoveContact extends React.Component<Props, State> {
    state = {
        isLoading: false
    }

    onClickCancelBtn = () => {
        this.props.onClose()
    }

    onClickRemove = async () => {
        const {data, t, isRelatedTo} = this.props
        let personalIdsToDelete = [data.id]
        if (isRelatedTo) {
            const response = await userPersonalContactsServiceV3.getAll({
                filter: {
                    userIds: [data.userId],
                    contactProfileIds: [data.profileId]
                }
            })
            personalIdsToDelete = response.data.map((item) => item.id)
        }

        this.setState({isLoading: true})
        try {
            if (data.type === "personal") {
                await userPersonalContactsServiceV3.delete(personalIdsToDelete)
            }
            if (data.type === "staff") {
                await studentStaffContactsServiceV3.delete([data.studentStaffContactId])
            }
            toastSuccess(t("common:message.deleteSuccess"))
            this.props.onClose()
        } catch (e) {
            toastError(t("common:message.deleteFailure"))
        } finally {
            this.setState({isLoading: false})
        }
    }

    render() {
        const {isShow, onClose, data, t, isRelatedTo} = this.props
        const {isLoading} = this.state

        return (
            <BasePopup isShow={isShow} onClose={onClose} leftIcon="DELETE" leftIconColor="#fff" width="70vw">
                <p className={styles.title}>Confirm</p>
                <div className={styles.removeBodyWrap}>
                    {isRelatedTo ? (
                        <p className={styles.removeText}>
                            {t("user:contact.deleteContact")}{" "}
                            <span className={styles.removeText__name}>
                                {" "}
                                {data.relatedTo && data.relatedTo.firstName} {data.relatedTo && data.relatedTo.lastName}
                            </span>{" "}
                            {t("user:contact.fromContactOf")}{" "}
                            <span className={styles.removeText__name}>
                                {data.contactProfile && data.contactProfile.firstName}{" "}
                                {data.contactProfile && data.contactProfile.lastName}
                            </span>
                            ?
                        </p>
                    ) : (
                        <p className={styles.removeText}>
                            {t("user:contact.deleteContact")}{" "}
                            <span className={styles.removeText__name}>
                                {" "}
                                {data.contactProfile && data.contactProfile.firstName}{" "}
                                {data.contactProfile && data.contactProfile.lastName}
                            </span>{" "}
                            {t("user:contact.fromContact")}
                        </p>
                    )}
                </div>
                <div className={styles.actionWrap}>
                    <Button className={styles.cancelBtn} onClick={this.onClickCancelBtn}>
                        {t("common:action.cancel")}
                    </Button>
                    <div className={styles.addBtnWrap}>
                        <BaseButton
                            title={t("common:action.delete")}
                            onClick={this.onClickRemove}
                            className={styles.addBtn}
                            loading={isLoading}
                        />
                    </div>
                </div>
            </BasePopup>
        )
    }
}
export default withTranslation(["user", "common"])(RemoveContact)
